import React from "react";

export function ArrowRightSmallIcon({ color = '#FFF', ...props }) {
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" stroke={color} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 1L5 5L1 9" />
    </svg>
  );
}
